import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getPaymentMethodDetails } from "../../helpers/http_payment_methods_requests";

export default function OrderPaymentMethodDetails() {

    const navigate = useNavigate();

    const { id } = useParams();

    const [formData, setFormData] = useState({});

    const formFieldList = [
        {
            title: "Atributos de Registro",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    useEffect(() => {
        getPaymentMethodDetails(id, setFormData);
    }, [id]);

    return <DynamicFormPage details initialData={formData} title={"Formas de Pagamento - Detalhes"} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;
};
